import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { storage } from '@/utils/browser';
import { REDIRECT_SCOPES } from '@/store/auth';

import { VIEWS } from './constants';

const CONFIG_KEY = 'my-images-config';

const DEFAULT_CONFIG = {
	view: VIEWS.GRID
};

export function useConfig() {
	const [config, setConfig] = useState(() => {
		const saved = storage.get(CONFIG_KEY);
		return { ...DEFAULT_CONFIG, ...saved };
	});

	return {
		config,
		setConfig(name, value) {
			const newConfig = { ...config, [name]: value };
			setConfig(newConfig);
			storage.save(CONFIG_KEY, newConfig);
		}
	};
}

export const AUTH_TRIGGER_QUERY = 'authTrigger';

export function useOauthRedirect() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		const authTrigger = searchParams.get(AUTH_TRIGGER_QUERY);

		if (authTrigger) {
			const [scope, type] = authTrigger.split('-');

			const redirectUrl = REDIRECT_SCOPES?.[scope]?.[type];

			setSearchParams({});

			if (redirectUrl?.startsWith('http')) {
				window.location.href = redirectUrl;

				return;
			}

			if (redirectUrl) {
				navigate(redirectUrl);
			}
		}
	}, []);
}
